import * as React from 'react';
import { IPredecessorInfo, PredecessorType, PredecessorTypeMetadata, isExternalPredecessor } from '../../../entities/Subentities';
import { formatValue } from '../../utils/common';
import { FormatType } from '../../../entities/Metadata';

export interface PredecessorFormatterProps {
    value?: IPredecessorInfo[];
}

const getPredecessorTypeMetadata = (type: any) => {
    if (typeof type === 'string' && isNaN(Number(type))) {
        return PredecessorTypeMetadata[PredecessorType[type as keyof typeof PredecessorType]];
    }
    const numericType = Number(type) as PredecessorType;
    return PredecessorTypeMetadata[numericType] || PredecessorTypeMetadata[PredecessorType.FinishToStart];
};

export const PredecessorFormatter: React.FC<PredecessorFormatterProps> = (props) => {
    const predecessors = props.value;
    if (!predecessors?.length) {
        return null;
    }
    
    return (
        <div className="icons-box">
            {predecessors.map(p => {
                const metadata = getPredecessorTypeMetadata(p.type);
                return (
                    <div key={p.id}>
                        {isExternalPredecessor(p)
                            ? `${p.name} (${p.projectName ?? p.projectId}) (${metadata.abbreviation}${p.lag < 0 ? "" : "+"}${formatValue(p.lag, FormatType.Days)})`
                            : `${p.name} (${metadata.abbreviation}${p.lag < 0 ? "" : "+"}${formatValue(p.lag, FormatType.Days)})`}
                    </div>
                );
            })}
        </div>
    );
};
